// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"ea01198a6ccfda2cebd4","111":"82802bdc8f43f2ee91b9","113":"1f2b16f54215f3e7c528","161":"88129a8b6d56be6738d7"}[chunkId] + ".chunk.js";
};